import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import Root from "@codeArt/apps/root";
import SolutionApp from "./project/apps/solution/index";
import MainApp from "./project/apps/main/index";
import AdminApp from "./project/apps/admin/index";
import ExtraApp from "./project/apps/extra/index";
import { initialize } from "./project/partials/pre_root_start";
import { host_url } from "project/constant/host";

const theme_yellow = {
  primary: "#9c8251",
  secondary: "#9c8251",
  app_header_bg: "#9c8251",
  sidebar: {
    text: "rgba(0, 0, 0, 0.6)",
    text_hover: "rgba(0, 0, 0, 0.87)",
    nav_active_bg: "#9c8251",
    nav_text_active: "#fff",
    nav_hover_bg: "rgb(229, 229, 229)",
  },
  multiPage:{
    text:"rgb(52, 58, 64)",
    text_active:"#fff",
    item_active_bg:"#9c8251",
  },
  loader:{
    bg:"#9c8251",
    color:"#fff"
  }
}

const date = new Date();
Root({
  project: {
    name: "智慧后勤企业门户系统",
    copyright: `智慧后勤 © ${date.getFullYear()}`,
    logo: {
      lg: {white: "/local/images/logo.png", deep: "",size:[132]}, //大图标,桌面端用
      sm: {white: "/local/images/logo-sm.png", deep: ""}, //小图标，移动端用
      redirect:"/main/home"
    },
    version: "1.0", //每次发布的时候需要更新版本号
    theme:theme_yellow
  },
  apps: [
    {path: "/main", component: MainApp, authable: true},
    {path: "/solution", component: SolutionApp, authable: true},
    {path: "/admin", component: AdminApp, authable: true},
    {component: ExtraApp} //默认会进入的页面
  ],
  initializes:[initialize],
  components:[
    // <Error />
  ], //存在整个页面框架下的公共组件
  portal: {
    logined: "/main/home", //用户登录后，如果没有输入具体路径，那么默认访问的地址
    login: "/login" //登录页，当用户没有登陆时，访问了需要授权的页面后会自动跳转到该页面
  },
  console:{}, //可以对控制台配置
  request:{ domain: host_url }   //默认的请求配置
});